import React, { FC } from 'react';
import { SystemButtonDefault, SystemButtonProps } from '../SystemButton';
import styles from './brand_secondary_button.module.scss';

export const BrandSecondaryButton: FC<SystemButtonProps> = ({
  children,
  onClick,
  type,
  disabled,
  dataName,
  id,
}) => {
  const commonProps = {
    className: styles.brandSecondary,
    disabled,
    name: dataName,
    id,
  };
  if (type === 'submit') {
    return (
      <button type="submit" {...commonProps}>
        {children}
      </button>
    );
  }
  return (
    <button type="button" onClick={onClick} {...commonProps}>
      {children}
    </button>
  );
};

BrandSecondaryButton.defaultProps = SystemButtonDefault;
